import React from "react";
import "../CSS/Alliances.css";

const Alliances = () => {
  return (
    <div className="alliances-container">
      <h1 className="alliances-title">Our Alliances & Partners</h1>
      <p className="alliances-subtitle">
        We collaborate with leading organizations to drive innovation in sustainability,
        technology, and green transformation. These partnerships help us deliver impactful
        and future-ready solutions.
      </p>

      <div className="alliances-grid">
        <div className="alliance-card">
          <h2>Efftronics</h2>
          <p>For IoT-based Water Sustainability and SCADA solutions.</p>
        </div>

        <div className="alliance-card">
          <h2>Endecarb</h2>
          <p>For Green Accounting, ESG, and Compliance Management.</p>
        </div>

        <div className="alliance-card">
          <h2>SkyPak</h2>
          <p>For Green Accounting, ESG, and Compliance Management.</p>
        </div>

        <div className="alliance-card">
          <h2>Global Business Services</h2>
          <p>For Distributed Asset Management solutions.</p>
        </div>

        <div className="alliance-card">
          <h2>Salzer</h2>
          <p>For Smart Energy Meter solutions and implementation.</p>
        </div>

        <div className="alliance-card">
          <h2>Vigorous One</h2>
          <p>
            For Green Accounting Consulting, Blockchain, Video Analytics, and Facial
            Recognition technologies.
          </p>
        </div>

        <div className="alliance-card">
          <h2>Aagama Consulting</h2>
          <p>
            For Modernisation of Legacy Applications, Business Analytics, and Artificial
            Intelligence.
          </p>
        </div>

        <div className="alliance-card">
          <h2>Chrome Data</h2>
          <p>For Impact Assessment Consulting and Data Analysis.</p>
        </div>

        <div className="alliance-card">
          <h2>Prashee Solar</h2>
          <p>For Solar Rooftop and Sustainable Energy Generation.</p>
        </div>
      </div>
    </div>
  );
};

export default Alliances;
